import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";

function Dashboard() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  console.log("uid", userId);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dash, setDash] = useState([]);

  const Dashboard_API = async () => {
    try {
      let responceRight = await API?.get(
        `/admindashboarddata?loginid=${userId}`,
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      responceRight = responceRight.data.data[0][0];
      console.log("Dashboard--->", responceRight);
      setDash(responceRight);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    Dashboard_API();
  }, []);

  return (
    <div>
      <Navbar />
      {/* {AdminRole.adminrole == "Admin" ? ( */}
      <>
        <div id="wrapper">
          <div class="content-page page_scroll_y">
            <div class="content">
              <div class="container">
                <div class="row">
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Registration</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalUser}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Registration</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayUser}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalactivation}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayactivation}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Activate CTO</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalInvest}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Activate CTO</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayInvest}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Total AutoPool CTO</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalInvest_autoPool}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's AutoPool CTO</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayInvest_autoPool}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div> */}

                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Booster CTO</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalInvest_booster}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Booster CTO</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayInvest_booster}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="DirectIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Direct Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.DirectIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="DirectIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Direct Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.T_DirectIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="LevelIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Level Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.RoiLevelIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="LevelIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Level Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.T_RoiLevelIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="PoolIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Pool Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.PoolIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="PoolIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Pool Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.T_PoolIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="RoyaltyIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Royalty Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.royaltyincome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="RoyaltyIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Royalty Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.T_royaltyincome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ClubIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Club Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.clubincome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ClubIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Club Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.T_clubincome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ClubIncomebooster">
                          <div class="gcp-description">
                            <div class="gcp-title">Booster Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.BoosterIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ClubIncomebooster">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Booster Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.T_BoosterIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="UplinewWithdrawalIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Upline Withdrawal Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {" "}
                                {dash.uplinewWithdrawalincome}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="UplinewWithdrawalIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Upline Withdrawal Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.T_uplinewWithdrawalincome}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="User_airdrop">
                          <div class="gcp-description">
                            <div class="gcp-title">Air Drop Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.user_airdrop}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="User_airdrop">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Air Drop Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.T_user_airdrop}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>*/}

                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Withdrawal</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.totalWithdrawal}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Withdrawal</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayWithdrawal}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Pending Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalPendingWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Pending Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayPendingWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div> */}
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Net Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalnetIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Net Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todaynetIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      {/* ) : (
        <>
          <div id="wrapper">
            <div class="content-page page_scroll_y">
              <div class="content">
                <div class="container">
                  <div class="row">
                    <h3>Welcome SubAdmin </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )} */}
    </div>
  );
}

export default Dashboard;
